import gql from 'graphql-tag';

export default gql`
subscription {
    onDeleteEtlPackage {
        __typename
        id
        name
        version
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlPackages/DeleteSubscription.js